import { render, staticRenderFns } from "./CreatedTasksResolvedList.vue?vue&type=template&id=1628c8b0"
import script from "./CreatedTasksResolvedList.vue?vue&type=script&lang=js"
export * from "./CreatedTasksResolvedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports